import * as Sentry from "@sentry/react";

import AppProvider from "@/app/providers/AppProvider";
import AppRouter from "@/app/router";
import AppErrorFallback from "@/shared/ui/layout/error/AppErrorFallback";

export default function App() {
  return (
    <div className="hide-scrollbar">
      <AppProvider>
        <Sentry.ErrorBoundary fallback={AppErrorFallback} showDialog>
          <AppRouter />
        </Sentry.ErrorBoundary>
      </AppProvider>
    </div>
  );
}
